export const DarkMode = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 437 280"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1462_13743)">
        <g filter="url(#filter0_d_1462_13743)">
          <mask
            id="path-2-outside-1_1462_13743"
            maskUnits="userSpaceOnUse"
            x="329.5"
            y="0"
            width="107"
            height="280"
            fill="black"
          >
            <rect fill="white" x="329.5" width="107" height="280" />
            <path d="M330.5 0H436.5V279.5H330.5V0Z" />
          </mask>
          <path
            d="M330.5 0H436.5V279.5H330.5V0Z"
            fill="#171A26"
            shapeRendering="crispEdges"
          />
          <rect
            width="106"
            height="53"
            transform="translate(330.5)"
            fill="#1F2332"
          />
          <rect
            x="361.875"
            y="11.25"
            width="43.25"
            height="7.5"
            rx="2"
            fill="#30374F"
          />
          <rect x="336.5" y="34" width="52" height="8" rx="2" fill="#30374F" />
          <rect x="336.5" y="45" width="52" height="8" rx="2" fill="#30374F" />
          <rect
            width="106"
            height="22.25"
            transform="translate(330.5 53)"
            fill="#1F2332"
          />
          <path
            d="M331.5 279.5V0H329.5V279.5H331.5Z"
            fill="#3A415F"
            mask="url(#path-2-outside-1_1462_13743)"
          />
        </g>
        <mask
          id="path-7-outside-2_1462_13743"
          maskUnits="userSpaceOnUse"
          x="119.5"
          y="0"
          width="212"
          height="280"
          fill="black"
        >
          <rect fill="white" x="119.5" width="212" height="280" />
          <path d="M120.5 0H330.5V279.5H120.5V0Z" />
        </mask>
        <path d="M120.5 0H330.5V279.5H120.5V0Z" fill="#171A26" />
        <mask id="path-9-inside-3_1462_13743" fill="white">
          <path d="M120.5 0H330.5V22H120.5V0Z" />
        </mask>
        <path d="M120.5 0H330.5V22H120.5V0Z" fill="#1F2332" />
        <rect
          x="132.5"
          y="7.875"
          width="37"
          height="6.25"
          rx="2"
          fill="#30374F"
        />
        <path
          d="M330.5 21H120.5V23H330.5V21Z"
          fill="#3A415F"
          mask="url(#path-9-inside-3_1462_13743)"
        />
        <rect
          x="216.75"
          y="166"
          width="101.75"
          height="30"
          rx="8"
          fill="#424DE5"
        />
        <rect
          x="132.5"
          y="206"
          width="101.75"
          height="30"
          rx="8"
          fill="#D2D5E3"
        />
        <g filter="url(#filter1_d_1462_13743)">
          <rect
            width="210"
            height="31.5"
            transform="translate(120.5 248)"
            fill="white"
          />
          <rect
            width="105"
            height="12"
            transform="translate(120.5 248)"
            fill="#1F2332"
          />
          <rect x="120.5" y="258" width="105" height="2" fill="#5A68ED" />
          <mask id="path-15-inside-4_1462_13743" fill="white">
            <path d="M225.5 248H330.5V260H225.5V248Z" />
          </mask>
          <path d="M225.5 248H330.5V260H225.5V248Z" fill="#1F2332" />
          <path
            d="M330.5 259H225.5V261H330.5V259Z"
            fill="#3A415F"
            mask="url(#path-15-inside-4_1462_13743)"
          />
          <rect
            width="210"
            height="19.5"
            transform="translate(120.5 260)"
            fill="#1F2332"
          />
          <rect
            x="124.5"
            y="264"
            width="171.25"
            height="11.5"
            rx="5.75"
            fill="#2F344C"
          />
          <rect
            x="303.75"
            y="264.5"
            width="22.75"
            height="10.5"
            rx="5.25"
            fill="#424DE5"
          />
        </g>
        <path
          d="M329.5 0V279.5H331.5V0H329.5ZM121.5 279.5V0H119.5V279.5H121.5Z"
          fill="#30374F"
          mask="url(#path-7-outside-2_1462_13743)"
        />
        <g filter="url(#filter2_d_1462_13743)">
          <rect
            width="104"
            height="22"
            transform="translate(16.5)"
            fill="#1F2332"
          />
          <rect
            x="28.5"
            y="7.875"
            width="43.25"
            height="6.25"
            rx="2"
            fill="#30374F"
          />
          <rect
            width="52"
            height="12"
            transform="translate(16.5 22)"
            fill="#1F2332"
          />
          <rect x="16.5" y="32" width="52" height="2" fill="#475AFF" />
          <mask id="path-23-inside-6_1462_13743" fill="white">
            <path d="M68.5 22H120.5V34H68.5V22Z" />
          </mask>
          <path d="M68.5 22H120.5V34H68.5V22Z" fill="#1F2332" />
          <path
            d="M120.5 33H68.5V35H120.5V33Z"
            fill="#3A415F"
            mask="url(#path-23-inside-6_1462_13743)"
          />
          <mask id="path-25-inside-7_1462_13743" fill="white">
            <path d="M16.5 34H120.5V52.5H16.5V34Z" />
          </mask>
          <path d="M16.5 34H120.5V52.5H16.5V34Z" fill="#1F2332" />
          <path
            d="M120.5 51.5H16.5V53.5H120.5V51.5Z"
            fill="#1F2333"
            mask="url(#path-25-inside-7_1462_13743)"
          />
          <g
            clipPath="url(#clip1_1462_13743)"
            filter="url(#filter3_i_1462_13743)"
          >
            <rect
              width="104"
              height="208"
              transform="translate(16.5 52.5)"
              fill="#171A26"
            />
            <rect
              x="25"
              y="61"
              width="87"
              height="30"
              rx="5.5"
              fill="#1F2332"
            />
            <rect
              x="25"
              y="61"
              width="87"
              height="30"
              rx="5.5"
              stroke="#1F2333"
            />
            <rect
              x="25"
              y="100"
              width="87"
              height="30"
              rx="5.5"
              fill="#1F2332"
            />
            <rect
              x="25"
              y="100"
              width="87"
              height="30"
              rx="5.5"
              stroke="#1F2333"
            />
            <rect
              x="25"
              y="139"
              width="87"
              height="30"
              rx="5.5"
              fill="#1F2332"
            />
            <rect
              x="25"
              y="139"
              width="87"
              height="30"
              rx="5.5"
              stroke="#1F2333"
            />
            <rect
              x="25"
              y="178"
              width="87"
              height="30"
              rx="5.5"
              fill="#1F2332"
            />
            <rect
              x="25"
              y="178"
              width="87"
              height="30"
              rx="5.5"
              stroke="#1F2333"
            />
            <rect
              x="25"
              y="217"
              width="87"
              height="30"
              rx="5.5"
              fill="#1F2332"
            />
            <rect
              x="25"
              y="217"
              width="87"
              height="30"
              rx="5.5"
              stroke="#1F2333"
            />
            <rect
              x="25"
              y="256"
              width="87"
              height="30"
              rx="5.5"
              fill="#1F2332"
            />
            <rect
              x="25"
              y="256"
              width="87"
              height="30"
              rx="5.5"
              stroke="#1F2333"
            />
          </g>
          <mask
            id="path-33-outside-8_1462_13743"
            maskUnits="userSpaceOnUse"
            x="16.5"
            y="259.5"
            width="104"
            height="20"
            fill="black"
          >
            <rect fill="white" x="16.5" y="259.5" width="104" height="20" />
            <path d="M16.5 260.5H120.5V279.5H16.5V260.5Z" />
          </mask>
          <path d="M16.5 260.5H120.5V279.5H16.5V260.5Z" fill="#1F2332" />
          <path
            d="M16.5 261.5H120.5V259.5H16.5V261.5Z"
            fill="#1F2333"
            mask="url(#path-33-outside-8_1462_13743)"
          />
          <path
            d="M119.5 0V279.5H121.5V0H119.5Z"
            fill="#3A415F"
            mask="url(#path-19-outside-5_1462_13743)"
          />
        </g>
        <mask
          id="path-35-outside-9_1462_13743"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="18"
          height="280"
          fill="black"
        >
          <rect fill="white" width="18" height="280" />
          <path d="M0 0H16.5V279.5H0V0Z" />
        </mask>
        <path d="M0 0H16.5V279.5H0V0Z" fill="#0D101C" />
        <rect x="6.25" y="12" width="4" height="12" rx="2" fill="#30374F" />
        <rect x="5.25" y="52" width="6" height="6" rx="2" fill="#30374F" />
        <rect x="5.25" y="66" width="6" height="6" rx="2" fill="#30374F" />
        <rect x="5.25" y="80" width="6" height="6" rx="2" fill="#30374F" />
        <rect x="5.25" y="94" width="6" height="6" rx="2" fill="#30374F" />
        <rect x="5.25" y="108" width="6" height="6" rx="2" fill="#30374F" />
        <path
          d="M15.5 0V279.5H17.5V0H15.5Z"
          fill="#3A415F"
          mask="url(#path-35-outside-9_1462_13743)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1462_13743"
          x="325.5"
          y="-3"
          width="115"
          height="287.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.121097 0 0 0 0 0.136234 0 0 0 0 0.197579 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1462_13743"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1462_13743"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_1462_13743"
          x="116.5"
          y="243"
          width="218"
          height="39.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0 0.196078 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1462_13743"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1462_13743"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_1462_13743"
          x="12.5"
          y="-3"
          width="113"
          height="287.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.121097 0 0 0 0 0.136234 0 0 0 0 0.197579 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1462_13743"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1462_13743"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_i_1462_13743"
          x="16.5"
          y="52.5"
          width="104"
          height="208"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.384314 0 0 0 0 0.427451 0 0 0 0 0.6 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1462_13743"
          />
        </filter>
        <clipPath id="clip0_1462_13743">
          <rect width="436.5" height="279.5" rx="12" fill="white" />
        </clipPath>
        <clipPath id="clip1_1462_13743">
          <rect
            width="104"
            height="208"
            fill="white"
            transform="translate(16.5 52.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
